import React from 'react';
import { baileyQuota, quotaCardCopy } from './usageRules';
import { shortDate } from './money';
import { openUpgrade } from './PricingBits';
import { hapticTick } from '../../_utils/haptics';
import './planUsage.css';

/**
 * Bailey's free questions, in the chat itself.
 *
 *   BaileyQuotaLine  "12 of 30 free questions this month", from half used;
 *                    with an upgrade nudge from 80%.
 *   BaileyQuotaCard  in place of a reply when the month's questions are
 *                    used: a friendly card with the upgrade, not an error.
 */
export function BaileyQuotaLine({ bailey, isOwner, now }) {
    if (!bailey) return null;
    const q = baileyQuota(bailey);
    if (!q.showCounter) return null;
    const back = shortDate(q.resetsAt, now);
    return (
        <div className={`pu-quota${q.nudge ? ' is-nudge' : ''}`} role="status" aria-live="polite">
            <span className="pu-quota-bar" aria-hidden="true"><span style={{ width: `${q.pct}%` }} /></span>
            <span>
                {q.label}
                {q.exhausted && back ? `. Back on ${back}` : ''}
            </span>
            {q.nudge && isOwner && !q.plus && (
                <button type="button" className="pu-link" onClick={() => { hapticTick(); openUpgrade({ from: 'bailey-counter' }); }}>
                    {q.exhausted ? 'Get Bailey Plus' : 'Get more'}
                </button>
            )}
        </div>
    );
}

export function BaileyQuotaCard({ quota, isOwner, now }) {
    const copy = quotaCardCopy(quota, now);
    return (
        <div className="agt-card pu-quota-card" role="status">
            <p className="bly-eyebrow">{copy.eyebrow || 'Free questions'}</p>
            <h4 className="bly-approve-title">{copy.title}</h4>
            <p className="agt-card-body">{copy.text}</p>
            {!copy.cta ? null : isOwner ? (
                <div className="bly-actions">
                    <button type="button" className="bly-btn is-primary" onClick={() => { hapticTick(); openUpgrade({ from: 'bailey-quota' }); }}>
                        {copy.cta}
                    </button>
                </div>
            ) : (
                <p className="pu-quota-resets">Ask the owner about Bailey Plus for more questions.</p>
            )}
        </div>
    );
}
